import React from 'react';
import { CTABand } from '../../components/CTABand';
export function AfterSchoolFinalCTA() {
  return <CTABand headline="Ready to Start at Storm Taekwondo?" copy="Talk to Storm about the best starting class or program for you or your child. We will help you find the right fit before your first visit." data-id="element-643" />;
}